// @flow @jsx h

// because of aria-label:
/* eslint-disable jsx-a11y/anchor-has-content */

import { h } from 'preact'
import { bem } from '@nrk/dh-utils'

import styles from './Logo.css'

type Props = {
  isBlack?: boolean,
  isHidden?: boolean
}

const Logo = ({ isBlack, isHidden }: Props) => {
  return (
    <div class={styles.logo__wrapper}>
      <a
        aria-hidden={isHidden}
        class={bem(styles.logo, { black: isBlack })}
        href='https://www.nrk.no'
        rel='home'
        aria-label='Gå til NRK.no'
      />
    </div>
  )
}

export { Logo }



// WEBPACK FOOTER //
// ./src/v1/components/Overlay/Logo.js